angular.module('app').directive('deepBlur', [ '$timeout', function ($timeout) {
    return {
        restrict: 'A',
        controller: [ '$scope', '$element', '$attrs', function ($scope, $element, $attrs) {
            var leaveExpr = $attrs.deepBlur,
                dom = $element[0];

            function containsDom(parent, dom) {
                while (dom) {
                    if (dom === parent) {
                        return true;
                    }

                    dom = dom.parentNode;
                }

                return false;
            }
            function onBlur(e) {
                // e.relatedTarget for Chrome
                // document.activeElement for IE 11
                var targetElement = e.relatedTarget || document.activeElement;

                if (!containsDom(dom, targetElement)) {
                    $timeout(function () {
                        $scope.$apply(leaveExpr);
                    }, 200);
                }
            }

            if (dom.addEventListener) {
                dom.addEventListener('blur', onBlur, true);
            } else {
                dom.attachEvent('onfocusout', onBlur); // For IE8
            }
        } ]
    };
} ])